import TeamzIcon from "@/assets/teamz.svg";
import { RefreshCcw } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";

export function Fallback() {
  const { t } = useTranslation(["common"]);

  return (
    <div className="flex h-full items-center justify-center px-4">
      <div className="flex w-full max-w-lg flex-col items-center gap-6 rounded-xl bg-white p-8 shadow-md">
        <TeamzIcon className="size-16" />

        <div>
          <h1 className="mb-2 text-balance text-center text-xl font-bold">
            {t("common:error-occured") }
          </h1>

          <h2 className="mb-4 text-balance text-center font-medium">
            {t("common:error-occured-msg")}
          </h2>
        </div>

        <Button
          variant="outline"
          className="w-full"
          onClick={() => {
            window.location.reload();
          }}
        >
          <RefreshCcw />
          {t("common:reload")}
        </Button>
      </div>
    </div>
  );
}
